import React from 'react';
import { InfoBarContainer } from './InfoBar.style';
import { useTranslation } from 'react-i18next';

export interface Props {
  /** obiekt z informacjami do wyświetlenia w formie klucz - wartość */
  content: {
    [key: string]: React.ReactElement | string | number | null;
  };
}
/**
 * Komponent wyświetlający informacje wraz z tytułem w formie ułożonych obok siebie bloków
 *
 */
export const InfoBar = (props: Props) => {
  const { t } = useTranslation();

  const iterateOnProps = () => {
    const { content } = props;
    const translated: React.ReactNode[] = [];
    for (const property in content) {
      translated.push(
        <li key={property}>
          <p className='header'>{t(property)}</p>
          <p>{content[property]}</p>
        </li>,
      );
    }
    return translated;
  };
  return <InfoBarContainer>{iterateOnProps()}</InfoBarContainer>;
};
export default InfoBar;
